import {
  ClickAwayListener,
  Grow,
  LinearProgress,
  Link,
  MenuItem,
  Paper,
  Popper,
} from "@mui/material";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import NoRowOverlay from "../../../assets/images/icons/NoRowOverlay";
import { ControlpanelPurple2thButton } from "../../../components/StyledButton";
import {
  CustomAdvancedMenuList,
  StyledDataGrid,
} from "../../../components/StyledComponents";
import CustomPagination from "../CustomPagination";
import SelectDataToExportUsersDialog from "../UserManagement/SelectDataToExportUsersDialog";
import SelectDataToImportUsersDialog from "../UserManagement/SelectDataToImportUsersDialog";
import ArrowRepeatIcon16pxSvg from "./../../../assets/images/icons/ArrowRepeatIcon16pxSvg";
import BoxArrowInDown16pxSvg from "./../../../assets/images/icons/BoxArrowInDown16pxSvg";
import BoxArrowInUp16pxSvg from "./../../../assets/images/icons/BoxArrowInUp16pxSvg";
import ChevronDownColor10pxSvg from "./../../../assets/images/icons/ChevronDownColor10pxSvg";
import PencilEditIcon16pxSvg from "./../../../assets/images/icons/PencilEditIcon16pxSvg";
import PersonXIcon16pxSvg from "./../../../assets/images/icons/PersonXIcon16pxSvg";
import QuestionIcon16pxSvg from "./../../../assets/images/icons/QuestionIcon16pxSvg";
import DefaultTooltip from "./../../../components/DefaultTooltip";
import DeleteAllUsersDialog from "./DeleteAllUsersDialog";
import RestoreDeletedUserDialog from "./RestoreDeletedUserDialog";
import SelectUsersForUserGroupDialog from "./SelectUsersForUserGroupDialog";
import { getListUserGroup } from "../../../axios/Group/GroupUrlApi";
import { format } from "date-fns";
import { useSelector } from "react-redux";
import AddUserToGroupDialog from "./AddUserToGroupDialog";
import { useAuth } from "../../../context/AuthContext";
import { generateTranslateMuiTable } from "../../../utils/Function/commonFunction";
import { toast } from "react-toastify";
import { useLoading } from "../../../context/LoadingContext";
import CustomColumnsPanel from "../../../components/CustomColumnsPanel";

const AttachedUsersFor = ({
  selectedRows,
  refreshData,
  handleRefreshTable,
  refreshInfo,
}) => {
  const { genaralSettingDateFormat, genaralSettingTimeFormat, dateTimeFormat } =
    useAuth();
  const { t, i18n } = useTranslation();
  const tableTranslated = useMemo(() => generateTranslateMuiTable(t), [t]);
  // const language = useSelector((state) => state.languageR.language);
  const currentLang = i18n.language;
  const [show, hide] = useLoading();

  const columnData = useMemo(
    () => [
      {
        field: "employeeCode",
        headerName: t("common.employeeCode"),
        minWidth: 150,
        flex: 1,
        renderCell: (params) =>
          params.value === null || params.value === undefined || params.value === ""
            ? "-"
            : params.value,
      },
      {
        field: "citizenNumber",
        headerName: t("common.content-131"),
        minWidth: 150,
        flex: 1,
      },
      {
        field: "fullName",
        headerName: t("common.full-name"),
        minWidth: 200,
        flex: 1,
      },

      { field: "email", headerName: t("common.email"), minWidth: 200, flex: 1 },

      {
        field: "phone", headerName: t("common.phone"), minWidth: 150, flex: 1, renderCell: (params) =>
          params.value === null || params.value === undefined || params.value === ""
            ? "-"
            : params.value,
      },
      {
        field: "createdAt",
        headerName: t("common.create-at"),
        minWidth: 200,
        flex: 1,
        hideable: true,
        rowSpanValueGetter: (value, row) =>
          row ? `${row.id}-${row.createdAt}` : value,
        valueFormatter: (value) => {
          if (value === null || value === undefined) return "-";
          const formatStr = dateTimeFormat || "dd/MM/yyyy HH:mm:ss";
          const formattedDate = format(new Date(value), formatStr);

          return formattedDate;
        },
      },
    ],
    [t, dateTimeFormat]
  );

  const [columnVisibilityModel, setColumnVisibilityModel] = useState({
    employeeCode: true,
    fullName: true,
    email: true,
    phone: true,
    createdAt: true,
    // modifiedTime: false,
    // isAdmin: false,
    // isActive: false,
  });
  const [rowData, setRowData] = useState([]);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(50);
  const [gridLoading, setGridLoading] = useState(false);
  const [filteredRowData, setFilteredRowData] = useState([]);
  const [filteredRowCount, setFilteredRowCount] = useState(0);
  const [rowCount, setRowCount] = useState(0);

  // const rowData = selectedRows.groupName.map((item, index) => ({
  //    id: index + 1,
  //    ...item,
  // }));

  useEffect(() => {
    const fetchData = async () => {
      const payload = {
        group: selectedRows?.id,
        pageNo: page + 1,
        recordPerPage: pageSize,
        langId: localStorage.getItem("i18nextLngId"),
      };
      show();
      try {
        const response = await getListUserGroup(payload);
        setRowCount(response.data.pagination.totalElements);
        setRowData(response.data.data);
        setFilteredRowData(response.data.data);
        setFilteredRowCount(response.data.pagination.totalElements);
      } catch (error) {
        if (error.response?.status !== 401) {
          toast.error(t(error?.response?.data.message) || t('common.network-timeout'));
        }
      } finally {
        hide();
      }
    };
    if (selectedRows?.id) {
      fetchData();
    }
  }, [selectedRows, t, page, pageSize, refreshData, refreshInfo]);

  const [openGroupUser, setOpenGroupUser] = useState(false);
  const anchorRefGroupUser = useRef(null);

  const handleToggleGroupUser = () => {
    setOpenGroupUser(!openGroupUser);
  };

  const handleCloseGroupUser = (event) => {
    if (
      anchorRefGroupUser.current &&
      anchorRefGroupUser.current.contains(event.target)
    ) {
      return;
    }
    setOpenGroupUser(false);
  };

  const [openDeleteAllUsers, setOpenDeleteAllUsers] = useState(false);

  const handleOpenDeleteAllUsers = () => {
    setOpenDeleteAllUsers(true);
  };

  const handleCloseDeleteAllUsers = () => {
    setOpenDeleteAllUsers(false);
  };

  const [openRestoreDeletedUser, setOpenRestoreDeletedUser] = useState(false);

  const handleOpenRestoreDeletedUser = () => {
    setOpenRestoreDeletedUser(true);
  };

  const handleCloseRestoreDeletedUser = () => {
    setOpenRestoreDeletedUser(false);
  };

  const [openSelectDataToImport, setOpenSelectDataToImport] = useState(false);

  const handleOpenSelectDataToImport = () => {
    setOpenSelectDataToImport(true);
  };

  const handleCloseSelectDataToImport = () => {
    setOpenSelectDataToImport(false);
  };

  const [openSelectDataToExport, setOpenSelectDataToExport] = useState(false);

  const handleOpenSelectDataToExport = () => {
    setOpenSelectDataToExport(true);
  };

  const handleCloseSelectDataToExport = () => {
    setOpenSelectDataToExport(false);
  };

  const [openSelectUserForUserGroup, setOpenSelectUserForUserGroup] =
    useState(false);

  const handleOpenSelectUserForUserGroup = () => {
    setOpenSelectUserForUserGroup(true);
  };

  const handleCloseSelectUserForUserGroup = () => {
    setOpenSelectUserForUserGroup(false);
  };

  const handleRowsPerPageChange = (newPageSize) => {
    // newPageSize ở đây tuỳ CustomPagination, có thể là event hoặc number
    const size =
      typeof newPageSize === "number"
        ? newPageSize
        : parseInt(newPageSize.target.value, 10);

    setPage((prevPage) => {
      // index của record đầu tiên đang xem
      const firstRowIndex = prevPage * pageSize;

      // page mới sao cho vẫn chứa record đó
      const newPage = Math.floor(firstRowIndex / size);

      // phòng trường hợp vượt quá số trang
      const maxPage = Math.max(
        0,
        Math.ceil(rowCount / size) - 1
      );

      return Math.min(newPage, maxPage);
    });

    setPageSize(size);
  };

  return (
    <div>
      <div className="mt-2">
        <StyledDataGrid
          sx={{
            height: selectedRows?.id === 1 ? "68vh" : "64vh",
            // height: 320,
            "& .MuiDataGrid-scrollbar--vertical, & .MuiDataGrid-scrollbar--horizontal":
            {
              display: "none !important",
            },

            /* KHÔNG chừa chỗ cho scrollbar nữa */
            "& .MuiDataGrid-scrollbarFiller": {
              display: "none !important",
            },
            "& .MuiDataGrid-columnHeaders": {
              paddingRight: 0,
            },
            "& .MuiDataGrid-topContainer": {
              paddingRight: 0,
            },

            "&": {
              "--DataGrid-scrollbarSize": "0px",
            },

            "& .MuiDataGrid-virtualScroller": {
              scrollbarWidth: "none",
            },
            "& .MuiDataGrid-virtualScroller::-webkit-scrollbar": {
              width: 0,
              height: 0,
            },
            "&:hover .MuiDataGrid-virtualScroller, &:focus-within .MuiDataGrid-virtualScroller":
            {
              scrollbarWidth: "thin",
            },
            "&:hover .MuiDataGrid-virtualScroller::-webkit-scrollbar, &:focus-within .MuiDataGrid-virtualScroller::-webkit-scrollbar":
            {
              width: 10,
              height: 10,
            },

            '& [class*="MuiDataGrid-scrollbar"][class*="--horizontal"]': {
              display: "none !important",
            },
            "& input[type=number]": {
              textAlign: "center",
              MozAppearance: "textfield",
              WebkitAppearance: "none",
              padding: "5px !important",
              height: "100%",
              pointerEvents: "none",
              caretColor: "transparent",
              userSelect: "none",
              paddingTop: "8px !important",
              paddingBottom: "8px !important"
            },
          }}
          rows={rowData}
          columns={columnData}
          loading={gridLoading}
          rowCount={rowCount}
          slots={{
            pagination: CustomPagination,
            loadingOverlay: LinearProgress,
            noRowsOverlay: NoRowOverlay,
            columnsPanel: CustomColumnsPanel,
          }}
          slotProps={{
            pagination: {
              page,
              count: rowCount,
              rowsPerPage: pageSize,
              onPageChange: setPage,
              onRowsPerPageChange: handleRowsPerPageChange,
            },
          }}
          localeText={tableTranslated}
          columnVisibilityModel={columnVisibilityModel}
          onColumnVisibilityModelChange={(newModel) =>
            setColumnVisibilityModel(newModel)
          }
        // onRowDoubleClick={handleRowDoubleClick}
        // onRowClick={handleRowClick}
        />
        {/* <StyledDataGrid
               rows={rowData}
               columns={columnData}
               slots={{
                  pagination: CustomPagination,
                  loadingOverlay: LinearProgress,
                  noRowsOverlay: NoRowOverlay,
               }}
               columnVisibilityModel={columnVisibilityModel}
               onColumnVisibilityModelChange={(newModel) => setColumnVisibilityModel(newModel)}
               rowSelection={false}
               initialState={{
                  filter: {
                     filterModel: {
                        items: [],
                        quickFilterValues: [''],
                     },
                  },
               }}
              
            /> */}
      </div>
      {/* <div className='mt-5 flex justify-end'>
            <div className='relative'>
               <ControlpanelPurple2thButton
                  onClick={handleToggleGroupUser}
                  ref={anchorRefGroupUser}
                  id='user-group-button'
                  aria-controls={openGroupUser ? 'user-group-menu' : undefined}
                  aria-expanded={openGroupUser ? 'true' : undefined}
                  aria-haspopup='true'
               >
                  <p>{t('button.group-users')}</p>
                  <ChevronDownColor10pxSvg />
               </ControlpanelPurple2thButton>
               <div>
                  <Popper
                     open={openGroupUser}
                     anchorEl={anchorRefGroupUser.current}
                     role={undefined}
                     placement='top-end'
                     transition
                     disablePortal
                     className='z-10'
                  >
                     {({ TransitionProps, placement }) => (
                        <Grow
                           {...TransitionProps}
                           style={{
                              transformOrigin: placement === 'bottom' ? 'left top' : 'left bottom',
                           }}
                        >
                           <Paper style={{ borderRadius: '6px' }} className='shadow-primary'>
                              <ClickAwayListener onClickAway={handleCloseGroupUser}>
                                 <CustomAdvancedMenuList id='group-user-menu' aria-labelledby='group-user-button'>
                                    <MenuItem
                                       style={{ borderBottom: '1px solid #E5E7EB' }}
                                       onClick={(e) => {
                                          handleOpenSelectUserForUserGroup();
                                          handleCloseGroupUser(e);
                                       }}
                                    >
                                       <Link>
                                          <PencilEditIcon16pxSvg />
                                          <p>{t('button.edit')}</p>
                                       </Link>
                                    </MenuItem>
                                    <MenuItem
                                       style={{ borderBottom: '1px solid #E5E7EB' }}
                                       onClick={(e) => {
                                          handleOpenSelectDataToImport();
                                          handleCloseGroupUser(e);
                                       }}
                                    >
                                       <Link>
                                          <BoxArrowInUp16pxSvg />
                                          <p>{t('button.import')}</p>
                                       </Link>
                                    </MenuItem>
                                    <MenuItem
                                       style={{ borderBottom: '1px solid #E5E7EB' }}
                                       onClick={(e) => {
                                          handleOpenSelectDataToExport();
                                          handleCloseGroupUser(e);
                                       }}
                                    >
                                       <Link>
                                          <BoxArrowInDown16pxSvg />
                                          <p>{t('button.export')}</p>
                                       </Link>
                                    </MenuItem>
                                    <MenuItem
                                       style={{ borderBottom: '1px solid #E5E7EB' }}
                                       onClick={(e) => {
                                          handleOpenDeleteAllUsers();
                                          handleCloseGroupUser(e);
                                       }}
                                    >
                                       <Link>
                                          <PersonXIcon16pxSvg />
                                          <p>{t('button.delete-all-users')}</p>
                                       </Link>
                                    </MenuItem>
                                    <MenuItem
                                       onClick={(e) => {
                                          handleOpenRestoreDeletedUser();
                                          handleCloseGroupUser(e);
                                       }}
                                    >
                                       <Link>
                                          <ArrowRepeatIcon16pxSvg />
                                          <p>{t('button.restore-deleted-users')}</p>
                                       </Link>
                                    </MenuItem>
                                 </CustomAdvancedMenuList>
                              </ClickAwayListener>
                           </Paper>
                        </Grow>
                     )}
                  </Popper>
               </div>
               <DeleteAllUsersDialog open={openDeleteAllUsers} handleClose={handleCloseDeleteAllUsers} info={selectedRows} handleRefreshTable={handleRefreshTable} />
               <RestoreDeletedUserDialog
                  open={openRestoreDeletedUser}
                  handleClose={handleCloseRestoreDeletedUser}
                  groupCode={selectedRows.groupCode}
               />
               {openSelectDataToImport && <SelectDataToImportUsersDialog onClose={handleCloseSelectDataToImport} />}
               {openSelectDataToExport && (
                  <SelectDataToExportUsersDialog
                     onClose={handleCloseSelectDataToExport}
                     idFilePassword='selectDataToExportUsersFilePasswordAttached'
                  />
               )}
                {openSelectUserForUserGroup && <AddUserToGroupDialog isOpen={openSelectUserForUserGroup} onClose={handleCloseSelectUserForUserGroup} info={selectedRows} handleRefreshTable={handleRefreshTable} userGroup={rowData}/>}

            </div>
         </div> */}
    </div>
  );
};

export default AttachedUsersFor;
